module.exports = __webpack_public_path__ + "media/public/img/madame-tussauds-logo-4cc97acdd9e3c2f2b44add7533338235.svg";